/** Client-side email format check (same rule as prior inline validation). */
export const EMAIL_VERIFICATION_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const LOGIN_REDIRECT_DELAY_MS = 1500;

export const EMAIL_VERIFICATION_LOGO_ALT = "NTCOG Logo";

export const EMAIL_VERIFICATION_PAGE_HEADING = "Create Account";
export const EMAIL_VERIFICATION_STEP_SUBTITLE = "Step 1 of 2: Verify your email";

export const EMAIL_VERIFICATION_EMAIL_FORM_ARIA_LABEL = "Register email verification form";
export const EMAIL_VERIFICATION_EMAIL_LABEL = "Email address";
export const EMAIL_VERIFICATION_REQUIRED_MARKER = "*";
export const EMAIL_VERIFICATION_EMAIL_PLACEHOLDER = "Enter your email address";
export const EMAIL_VERIFICATION_EMAIL_HELP =
  "Enter the email address that received the invitation";
export const EMAIL_VERIFICATION_EMAIL_SUBMIT_LOADING = "Checking eligibility…";
export const EMAIL_VERIFICATION_EMAIL_SUBMIT = "Continue";

export const EMAIL_VERIFICATION_CODE_FORM_ARIA_LABEL = "Register verification code form";
export const EMAIL_VERIFICATION_CODE_SENT_PREFIX = "Verification code sent to";
export const EMAIL_VERIFICATION_CODE_LABEL = "Verification Code";
export const EMAIL_VERIFICATION_CODE_PLACEHOLDER = "Enter your verification code";
export const EMAIL_VERIFICATION_CODE_HELP = "Check your email for the verification code";
export const EMAIL_VERIFICATION_CODE_BACK = "Back";
export const EMAIL_VERIFICATION_CODE_SUBMIT_LOADING = "Verifying…";
export const EMAIL_VERIFICATION_CODE_SUBMIT = "Verify & Continue";

export const EMAIL_VERIFICATION_LOGIN_LINK = "Already have an account? Login";

export const EMAIL_VERIFICATION_ERROR_EMAIL_REQUIRED = "Email is required";
export const EMAIL_VERIFICATION_ERROR_EMAIL_INVALID = "Please enter a valid email address";
export const EMAIL_VERIFICATION_ERROR_CODE_REQUIRED = "Verification code is required";

export const EMAIL_VERIFICATION_SUCCESS_CODE_SENT = "Verification code sent to your email";
export const EMAIL_VERIFICATION_SUCCESS_LOGIN_REDIRECT =
  "You already have an account. Redirecting to login...";
export const EMAIL_VERIFICATION_ERROR_UNEXPECTED_RESPONSE = "Unexpected response. Please try again.";
/** Shown on 401; intentionally differs from API detail wording. */
export const EMAIL_VERIFICATION_ERROR_INVALID_INVITATION =
  "This email does not have a valid invitation. Please contact your administrator to request an invitation.";
export const EMAIL_VERIFICATION_ERROR_VERIFY_FAILED = "Unable to verify email";
export const EMAIL_VERIFICATION_ERROR_REQUEST_FAILED = "Unable to process request. Please try again.";
